import { withTheme, css } from 'styled-components'
import { Box } from 'rebass'
import { height, width } from 'styled-system'
import Text from './Text'

const Radio = withTheme(props => {
  return (
    <Box
      css={[
        `
          position:relative;
          margin: 5px 0 0 0;
          display: inline-block;
        `,
        width,
        height
      ]}
      {...props}>
      <Text
        {...props}
        as={'input'}
        type={'radio'}
        css={`
          display: none;
        `}
      />
      <Box
        {...props}
        css={[
          `
            cursor:pointer;
            padding-right: 5px;
            width:14px;
            height:14px;
            border-radius: 10px;
            background:#ffffff;
            border: ${props.error ? `1px solid ${props.theme.colors.red.default}` : '1px solid #dadada'};
            :after {
                background: #ffffff;
                content: "";
                position: absolute;
                border-radius: 10px;
                margin: 1px;
            }
          `,
          props =>
            props.checked
              ? css`
                  background-color: ${props.theme.colors.primary};
                  border: 1px solid ${props.theme.colors.primary};
                  :after {
                    background: #ffffff;
                    width: 6px;
                    height: 6px;
                    top: 3px;
                    left: 3px;
                  }
                `
              : ''
        ]}
      />
    </Box>
  )
})

Radio.defaultProps = {
  width: '20px',
  height: '20px'
}

export default Radio
